import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string} */
const initialState = null;

const reset = () => null;

const setError = (_, { payload }) => payload;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_TOP_CONTRIBUTORS_REQUEST]: reset,
  [types.FETCH_STATISTICS_TOP_CONTRIBUTORS_FAILURE]: setError,
});
